import gestionErreur from '@/services/general/gestionErreur';
import { getSymbols } from '@/api/asterop';
import { getAll, setAll, getParamAffixe2 } from '@/api/parametrage/index';
import * as allTypes from '../mutation-type';
import * as types from './parametrage-mutation-type';

function initialState() {
  return {
    parametrages: [],
    symboles: null,
    paramAffixe2: {},
    isActivationYield: false,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_PARAMETRAGES](state, Parametrages) {
    state.parametrages = Parametrages;
  },
  [types.SET_SYMBOLES](state, symboles) {
    state.symboles = symboles;
  },
  [types.SET_PARAM_AFFIXE2](state, payload) {
    state.paramAffixe2[payload.key] = payload.value;
  },
  [types.SET_ACTIVATION_YIELD](state, isActivationYield) {
    state.isActivationYield = isActivationYield;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  rechercheParametrages: ({ commit }) => {
    return new Promise((resolve, reject) => {
      getAll().then((response) => {
        commit(types.SET_PARAMETRAGES, response.data);
        resolve();
      }).catch((e) => {
        reject(e.code);
        gestionErreur('Erreur lors de la récupération des parametres', e);
      });
    });
  },
  sauvegardeParametrages: ({ commit }, parametrages) => {
    return new Promise((resolve, reject) => {
      setAll(parametrages).then((response) => {
        commit(types.SET_PARAMETRAGES, response.data);
        resolve();
      }).catch((e) => {
        reject(e.code);
        gestionErreur('Erreur lors de la sauvegarde des parametres', e);
      });
    });
  },
  async loadSymboles({ getters, commit }) {
    const symbols = {};
    if (getters.symboles) {
      return;
    }
    const response = await getSymbols();
    response.data.symbols.forEach((item, index) => {
      symbols[item] = response.data.images[index];
    });
    commit(types.SET_SYMBOLES, symbols);
  },
  loadParamAffixe2: async ({ commit }, key) => {
    const { result } = (await getParamAffixe2(key)).data;
    commit(types.SET_PARAM_AFFIXE2, { key, value: result });
    commit(types.SET_ACTIVATION_YIELD, result);
  },
};

const getters = {
  parametrages: state => {
    return state.parametrages;
  },
  symboles: state => {
    return state.symboles;
  },
  affixe2: state => {
    if (state.parametrages.length === 0) return '';
    return state.parametrages.filter(el => el.cle === 'Affixe2')[0].valeurBoolean;
  },
  paramAffixe2: state => {
    return state.paramAffixe2;
  },
  isActivationYield: state => {
    if (typeof state.isActivationYield === 'string') return (state.isActivationYield === 'true');
    if (typeof state.isActivationYield === 'boolean') return state.isActivationYield;
    return false;
  },
};


export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/parametrage.js